export enum DsLinearEnum {
  V1_DS_LINEAR_ENDPOINT = '/v1/dslinear/projects/',
}
